import React from 'react';
import { useTranslation } from 'localization';
import './NotificationDotAtom.scss';

export type NotificationPriority = 'low' | 'normal' | 'high' | 'urgent';

export interface NotificationDotAtomProps {
  isUnread: boolean;
  priority?: NotificationPriority;
  className?: string;
}

/**
 * NotificationDotAtom - Unread indicator dot
 * Similar to NotificationBell's .notification-unread-indicator
 */
const NotificationDotAtom: React.FC<NotificationDotAtomProps> = ({
  isUnread,
  priority = 'normal',
  className = ''
}) => {
  const { t } = useTranslation();
  if (!isUnread) {
    return null;
  }

  return (
    // role="img": aria-label is prohibited on a generic <div> (axe aria-prohibited-attr), and
    // the dot carries meaning rather than decoration — it is the only thing saying "unread".
    <div
      className={`notification-dot-atom notification-dot-atom--${priority} ${className}`}
      role="img"
      aria-label={t('notifications.unreadIndicator')}
    />
  );
};

export default NotificationDotAtom;